/**
 * shell/* catalog registry for the `en` locale (one module per top-level src/<dir>).
 * Generated layout: every module keeps its three locales side by side in
 * ./<module>/{fr,en,ar}.ts so each locale bundles into its own chunk.
 */

import type { ShellCatalog } from './fr';
import app from './app/en';
import auth from './auth/en';
import components from './components/en';
import features from './features/en';
import lib from './lib/en';
import stores from './stores/en';
import ui from './ui/en';

export const shellEn: ShellCatalog = {
  app,
  auth,
  components,
  features,
  lib,
  stores,
  ui,
};
